import CheckmarkOutline20 from '@carbon/icons-react/es/checkmark--outline/20';
import ErrorOutline20 from '@carbon/icons-react/es/error--outline/20';
import Information20 from '@carbon/icons-react/es/information/20';
import Warning20 from '@carbon/icons-react/es/warning/20';
import React from 'react';
import ReactDOM from 'react-dom';
import { DocumentInfoPanelTypes } from 'vendor/ckeditor/plugins/info-panel/constants';

export const infoPanelRenderer = (icon, container) => {
  const getPanelIcon = () => {
    switch (icon) {
      case DocumentInfoPanelTypes.Info:
        return <Information20 color="var(--blue-50)" />;
      case DocumentInfoPanelTypes.Success:
        return <CheckmarkOutline20 color="var(--green-50)" />;
      case DocumentInfoPanelTypes.Warning:
        return <Warning20 color="var(--yellow-40)" />;
      case DocumentInfoPanelTypes.Error:
        return <ErrorOutline20 color="var(--red-50)" />;
      default:
        return <Information20 color="var(--blue-50)" />;
    }
  };

  if (icon) {
    ReactDOM.render(getPanelIcon(), container);
  }
};
